import styled from 'styled-components';

const CollapseButton = styled.button`
  color: ${(props): string => props.theme.colors.pureWhite};
  font-size: 1.2rem;
  margin-left: auto;
  background: none;
  border: 0;
  padding: 0;

  &:hover {
    cursor: pointer;
    font-weight: ${(props): number => props.theme.fontWeight.medium};
    text-decoration: underline;
  }
`;

export { CollapseButton };
